<template>
  <div>
    <div v-if='fillingDeta.subjectType === 0'>
      <ep-title title="备案信息"></ep-title>
      <!-- <p class="title">
        <span>备案流水号： {{fillingDeta.serialCode}}</span>
      </p> -->
      <div class="plne-list">
        <div class="table-item">
          <div class="plne-state">
            <i class="icon iconfont icon-wancheng" :class="{succ: fillingDeta.subjectFillState ===2 }"></i>
            <span class="info">
              <i>申报单位信息</i>
              <i v-if='fillingDeta.subjectFillState === 2'>状态：
                <span class="succ">完成</span>
              </i>
              <i v-else>状态：
                <span class="err">未完成</span>
              </i>
            </span>
          </div>
          <div class="infos">
            <table border="0" cellspacing="0" cellpadding="0" class="table">
              <tbody>
                <tr>
                  <td class="width200">企业全称</td>
                  <td>{{fillingDeta.subjectName}}</td>
                  <td class="width120">中心坐标</td>
                  <td>东经：{{fillingDeta.longitude | formatDegree}}，北纬：{{fillingDeta.latitude | formatDegree}}</td>
                </tr>
                <tr>
                  <td class="width200">统一社会信用代码</td>
                  <td>{{fillingDeta.code}}</td>
                  <td class="width120">营业执照</td>
                  <td>
                    <a href="javascript:void(0)" class='bigImg' @click='previewImg(fillingDeta.imgName)'>查看大图</a>
                  </td>
                </tr>
                <tr>
                  <td class="width200">企业法人</td>
                  <td>{{fillingDeta.legalPerson}}</td>
                  <td class="width120">联系电话</td>
                  <td>{{fillingDeta.phone}}</td>
                </tr>
                <tr>
                  <td class="width200">注册地址</td>
                  <td>{{fillingDeta.address}}</td>
                  <td class="width120" v-show="fillingDeta.zone">所属工业园区</td>
                  <td v-show="fillingDeta.zone">{{formatZone(fillingDeta.zone)}}</td>
                </tr>
                <tr>
                  <td class="width200">所属区划类型</td>
                  <td>{{formatRegionType(fillingDeta.regionType)}}</td>
                  <td class="width120">所属区划</td>
                  <td>{{getRegions(fillingDeta.regions)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="table-item">
          <div class="plne-state">
            <i class="icon iconfont icon-wancheng" :class="{succ: fillingDeta.planInfoFillState===2 }"></i>
            <span class="info">
              <i>预案信息</i>
              <i v-if='fillingDeta.planInfoFillState === 2'>状态：
                <span class="succ">完成</span>
              </i>
              <i v-else>状态：
                <span class="err">未完成</span>
              </i>
            </span>
          </div>
          <div class="info-list">
            <div class='title'>
              风险等级： {{formatIndustryType(fillingDeta.riskLevel)}}
            </div>
            <div style="width:99%">
              <div class="tab">
                <span class="span-border">风险物质</span>
                <el-table :data="fillingDeta.riskyMaterial" border style="width: 100%" height="250">
                  <el-table-column label="序号" width="80" header-align="center" align="center" type="index">
                  </el-table-column>
                  <el-table-column prop="name" label="风险物质名称">
                  </el-table-column>
                  <el-table-column prop="state" label="形态">
                    <template slot-scope="scope">
                      {{formatIndustrystate(scope.row.state)}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="count" label="数量">
                  </el-table-column>
                  <el-table-column prop="unit" label="单位">
                  </el-table-column>
                  <el-table-column prop="storage" label="储存方式">
                  </el-table-column>
                </el-table>
              </div>
              <div class="tab">
                <span class="span-border">应急物资</span>
                <el-table :data="fillingDeta.emergencyMaterial" border style="width: 100%" height="250">
                  <el-table-column label="序号" width="80" header-align="center" align="center" type="index">
                  </el-table-column>
                  <el-table-column prop="name" label="名称">
                  </el-table-column>
                  <el-table-column prop="function" label="作用">
                  </el-table-column>
                  <el-table-column prop="count" label="数量">
                  </el-table-column>
                  <el-table-column prop="location" label="放置场所">
                  </el-table-column>
                  <el-table-column prop="department" label="使用部门">
                  </el-table-column>
                </el-table>
              </div>
              <div class="tab">
                <span class="span-border">敏感保护目标</span>
                <el-table :data="fillingDeta.sensitiveProtection" border style="width: 100%" height="250">
                  <el-table-column label="序号" width="80" header-align="center" align="center" type="index">
                  </el-table-column>
                  <el-table-column prop="type" label="类型">
                    <template slot-scope="scope">
                      {{formatIndustry(scope.row.type)}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="名称">
                  </el-table-column>
                  <el-table-column prop="longitude" label="经度">
                    <template slot-scope="scope">
                      {{scope.row.longitude | formatDegree}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="latitude" label="纬度">
                    <template slot-scope="scope">
                      {{scope.row.latitude | formatDegree}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="description" label="描述">
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="fillingDeta.subjectType === 1">
      <p class="title">
        <span>备案流水号： {{fillingDeta.serialCode}}</span>
      </p>
      <div class="plne-list">
        <div class="table-item">
          <div class="plne-state">
            <i class="icon iconfont icon-wancheng" :class="{succ: fillingDeta.subjectFillState ===2 }"></i>
            <span class="info">
              <i>申报单位信息</i>
              <i v-if='fillingDeta.subjectFillState === 2'>状态：
                <span class="succ">完成</span>
              </i>
              <i v-else>状态：
                <span class="err">未完成</span>
              </i>
            </span>
          </div>
          <div class="infos">
            <table border="0" cellspacing="0" cellpadding="0" class="table">
              <tbody>
                <tr>
                  <td class="width200">企业全称</td>
                  <td>{{fillingDeta.subjectName}}</td>
                  <td class="width120">中心坐标</td>
                  <td>东经：{{fillingDeta.longitude | formatDegree}}，北纬：{{fillingDeta.latitude | formatDegree}}</td>
                </tr>
                <tr>
                  <td class="width200">单位地址</td>
                  <td>{{fillingDeta.address}}</td>
                  <td class="width120">所属区划</td>
                  <td>{{getRegions(fillingDeta.regions)}}</td>
                </tr>
                <tr>
                  <td class="width200">联系人</td>
                  <td>{{fillingDeta.linkMan}}</td>
                  <td class="width120">联系电话</td>
                  <td>{{fillingDeta.phone}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="table-item" v-if="none_box">
      <div class="plne-state">
        <i class="icon iconfont icon-wancheng" :class="{succ: fillingDeta.planDocFillState===2 }"></i>
        <span class="info">
          <i>上传备案文件</i>
          <i v-if='fillingDeta.planDocFillState === 2'>状态：
            <span class="succ">完成</span>
          </i>
          <i v-else>状态：
            <span class="err">未完成</span>
          </i>
        </span>
      </div>
      <div class="filing-file">
        <div class="file-list">
          <ul>
            <li v-for='(item,i) in fillingDeta.plandoc' :key="i" v-if='fillingDeta.plandoc'>
              <i class="iconfont icon icon-dian-copy-copy"></i>
              <span class="ml">{{formatPlanDoc(item.type)}}</span>
              <div v-if='item.type===51 || item.type===1' style="padding-left:25px">
                <img class="pdf-box" v-if="imgshow==1" @click='previewImg("",true,item.id)' :src="showImg(item.id,item.fileName)" width='100' height="100">
              </div>
              <div v-else>
                <a href="javascript:void(0)" title="下载" @click="downloadFiles(item.id)">{{item.fileName}}</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog title="营业执照" v-model="dialogVisible" size="tiny">
      <img :src='imageSrc' width="100%" />
    </el-dialog>
  </div>
</template>
<script>
import fillingInfo from './../../data/basic/weather/filling';
import pdf from 'vue-pdf';
export default {
    components: {
        pdf
    },
    data() {
        return {
            dialogVisible: false,
            imgshow: 1,
            planId: "",
            fillingDeta: {},
            imageSrc: "",
            none_box: false
        };
    },
    created() {
        this.planId = sessionStorage.planIdLists;
        if (!this.planId) return;
        this.fillingInfo({
            planId: this.planId
        });
    },
    methods: {
        fillingInfo(data) {
            (async () => {
                let planInfo = await fillingInfo.get_fillingInfo(data);
                if (planInfo.status) {
                    this.fillingDeta = planInfo.data;
                }
                this.none_box = true;
            })();
        },
        previewImg(src, type, id) {
          let TOKEN = sessionStorage.getItem('publicToken')
            if (type) {
              if(id){
                this.imageSrc = `/api/emer/plandoc/download?id=${id}&isOnline=true`;
              }
            } else {
                if (src) {
                  let arr = src.replace(/^;/,'').replace(/;$/,'').split(';')
                  if (arr.length == 1 && arr != '' && arr[0]) {
                      this.imageSrc = `/api/basic/img/get?name=${arr[0]}&AccessToken=${TOKEN}`
                  } else if (arr.length > 1 && arr[1]) {
                      this.imageSrc = `/api/basic/img/get?name=${arr[1]}&AccessToken=${TOKEN}`
                  } else {
                    this.imageSrc =  './../../../static/img/000.png'
                  }
                }else{
                    this.imageSrc =  './../../../static/img/000.png'
                }
            }
            this.dialogVisible = true;
        },
        formatZone(zone) {
            if (!zone) return "暂无工业园区";
            return zone.name;
        },
        formatEaer(zone) {
            if (!zone) return "";
            return `${zone.provinceName},${zone.cityName},${zone.countyName}`;
        },
        formatRegionType(regionType) {
            let regionName = "";
            switch (regionType) {
                case 1:
                    regionName = "单个区县";
                    break;
                case 2:
                    regionName = "跨区县";
                    break;
                case 3:
                    regionName = "跨市";
                    break;
            }
            return regionName;
        },
        downloadFiles(id) {
          if(id){
            window.location.href = `/api/emer/plandoc/download?id=${id}&isOnline=false`;
          }
        },
        getRegions(regions) {
            if (!regions) return;
            let regionsName = "";
            for (let i = 0; i < regions.length; i++) {
                regionsName +=
                    regions[i].province.name + "," + regions[i].city.name + ",";
                for (let k = 0; k < regions[i].county.length; k++) {
                    if (regions[i].county[k].name) {
                        regionsName += regions[i].county[k].name + ",";
                    }
                }
            }
            return regionsName.substring(0, regionsName.length - 1);
        },
        formatPlanDoc(num, filename) {
          let docName = ''
          switch (num) {
            case 1:
              docName = '备案表'
              break
            case 2:
              docName = '应急预案'
              break
            case 3:
              docName = '风险评估报告'
              break
            case 4:
              docName = '应急资源调查报告'
              break
            case 5:
              docName = '专家评审意见书'
              break
            case 6:
              docName = '补充其他（平面图等）'
              break
            case 7:
              docName = '审查意见书'
              break
            case 8:
              docName = '编制说明'
              break
            case 51:
              docName = '备案表'
              break
            case 52:
              docName = '应急预案'
              break
            case 53:
              docName = '专家评审意见书'
              break
            case 54:
              docName = '应急响应减排措施及现场核查表'
              break
            case 55:
              docName = '审查意见书'
              break
            case 98:
              docName = '其他 '
              break
            case 99:
              docName = '其他 '
              break
            default:
              docName = "其他 ";
              break;
          }
          return docName
        },
        //
        showImg(id, filename) {
          if(!id) return;
            let file_name = /\.[^\.]+/.exec(filename);
            if (
                file_name[0] == ".pdf" ||
                file_name[0] == ".png" ||
                file_name[0] == ".jpg"
            ) {
                if (file_name[0] === ".pdf") {
                    this.imgshow = 2;
                } else {
                    this.imgshow = 1;
                }
            }
            return `/api/emer/plandoc/download?id=${id}&isOnline=true`;
        },
        // 风险等级
        formatIndustryType(num) {
            let industryType = "";
            switch (num) {
                case 1:
                    industryType = "一般";
                    break;
                case 2:
                    industryType = "较大";
                    break;
                case 3:
                    industryType = "重大";
                    break;
            }
            return industryType;
        },
        // 形态
        formatIndustrystate(num) {
            let industryType = "";
            switch (num) {
                case 1:
                    industryType = "固态";
                    break;
                case 2:
                    industryType = "液态";
                    break;
                case 3:
                    industryType = "气态";
                    break;
            }
            return industryType;
        },
        // 形态
        formatIndustry(num) {
            let industryType = "";
            switch (num) {
                case 1:
                    industryType = "学校";
                    break;
                case 2:
                    industryType = "医院";
                    break;
                case 3:
                    industryType = "村庄";
                    break;
                case 4:
                    industryType = "社区";
                    break;
                case 5:
                    industryType = "水源地";
                    break;
            }
            return industryType;
        }
    }
};
</script>
<style lang="stylus" scoped>
.infos {
  width: 100%;

  .table {
    width: 100%;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    tr {
      line-height: 45px;

      td {
        box-sizing: border-box;
        padding: 0 10px;
        border-left: 1px solid #ccc;
        border-top: 1px solid #ccc;
        font-size: 14px;
        color: #1f2d3d;

        &.width120 {
          width: 120px;
        }

        &.width200 {
          width: 180px;
        }
      }
    }
  }

  .bigImg {
    color: #20a0ff;
  }
}

.title {
  line-height: 30px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #1f2d3d;
}

.plne-list {
  position: relative;
  width: 100%;
}

.table-item {
  margin-bottom: 20px;
}

.plne-state {
  margin-bottom: 20px;

  .icon {
    font-size: 46px;
    color: #58d043;

    &.succ {
      color: #58d043;
    }

    &.err {
      color: #f00;
    }
  }

  .info {
    display: inline-block;
    line-height: 24px;

    i {
      font-size: 14px;
      display: block;
      font-style: normal;

      span.succ {
        color: #58d043;
      }

      span.err {
        color: #f00;
      }
    }
  }
}

.filing-file {
  height: auto;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.file-list {
  margin-top: 10px;
  padding-left: 30px;

  li {
    margin-bottom: 15px;
    list-style: none;
  }

  .icon {
    color: #0381f0;
  }

  a {
    text-decoration: underline;
    display: block;
    margin-left: 26px;
    line-height: 30px;
    font-size: 14px;
    color: #1f2d3d;

    i {
      font-size: 40px;
    }
  }

  .ml {
    margin-left: 10px;
  }
}

.info-list {
  border: 1px solid #ccc;
  box-sizing: border-box;

  .title {
    height: 50px;
    border-bottom: 1px solid #ccc;
    line-height: 50px;
    box-sizing: border-box;
    padding-left: 10px;

    span {
      margin-left: 30px;
      width: 90%;
    }
  }

  .tab {
    width: 99%;
    margin-bottom: 10px;
    margin-left: 10px;
  }
}

.pdf-box {
  height: 100px;
  width: 100px;
  overflow: hidden;
  border: 1px solid #ccc;
  margin-top: 10px;
  padding: 5px;
}

.span-border {
  text-indent: 2em;
  font-size: 15px;
  color: #131415;
  border-left: 3px #20a0ff solid;
  padding: 0 10px;
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// fillingInfo.vue?6596ffae